export default {
  banner_text:
    "We use cookies to run the app (essential) and improve it (analytics). Choose what you allow.",
  essential_required: "Essential (required)",
  analytics: "Analytics",
  marketing: "Marketing",
  allow_essential_only: "Allow essential only",
  save_choices: "Save choices",
  accept_all: "Accept all",
  aria_label: "Cookie consent"
};
